import { Trait } from "../../../types/onboarding";

const TRAIT_STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  DEATH: { bg: "#fde2e2", fg: "#b32424", label: "Fallecimiento" },
  DISABILITY: { bg: "#fff3cd", fg: "#856404", label: "Invalidez" },
  MALATTIA_TERMINALE: {
    bg: "#f3e8ff",
    fg: "#6f42c1",
    label: "Enf. terminal",
  },
  SERIOUS_ILLNESS: {
    bg: "#f3e8ff",
    fg: "#6f42c1",
    label: "Enf. graves",
  },
};

const FALLBACK = { bg: "#e9ecef", fg: "#495057" };

const formatCapital = (n: number) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export default function TraitsBadges({ traits }: { traits: Trait[] }) {
  if (!traits || traits.length === 0) return <span style={{ color: "#73879C" }}>—</span>;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.25rem" }}>
      {traits.map((t) => {
        const style = TRAIT_STYLES[t.trait] ?? { ...FALLBACK, label: t.trait };
        return (
          <span
            key={t.trait}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.3rem",
              padding: "0.15rem 0.5rem",
              borderRadius: "0.35rem",
              fontSize: ".7rem",
              fontWeight: 500,
              background: style.bg,
              color: style.fg,
              whiteSpace: "nowrap",
            }}
            title={t.trait}
          >
            <span>{style.label}</span>
            <strong>{formatCapital(t.capital)}</strong>
          </span>
        );
      })}
    </div>
  );
}
